<template>
  <router-view :key="fullPath" />
</template>
<script setup>
import { useRoute } from 'vue-router';
import { ref, watch } from 'vue';

const route = useRoute();
const fullPath = ref('');

console.log(process.env.NODE_ENV, '环境');

watch(route, (newval) => {
  fullPath.value = newval.fullPath;
});

</script>
<style lang="scss">
@import '~@/assets/css/reset.scss';
</style>
